// Firestore has no substring search: the honest contract (spec 024, Screens) is
// exact phone match + prefix name/email, tried in two case variants.
export const classifyTerm = (raw) => {
  const term = (raw || "").trim();
  const digits = term.replace(/[\s()-]/g, "");
  if (/^\+?\d{5,}$/.test(digits)) {
    const bare = digits.replace(/^\+/, "");
    return { kind: "phone", values: [...new Set([digits, digits.startsWith("+") ? bare : `+${bare}`])] };
  }
  const cap = term.charAt(0).toUpperCase() + term.slice(1).toLowerCase();
  const low = term.toLowerCase();
  return { kind: "text", values: [...new Set([term, term === low ? cap : low])] };
};

export const mergeResults = (lists) => {
  const seen = new Set();
  return lists.flat().filter((r) => (seen.has(r.id) ? false : seen.add(r.id)));
};
